import React from "react";
import ReactDOM from "react-dom/client";

import "./styles/variables.css";
import "./styles/reset.css";

import "./index.css";
import AppRouter from "./AppRouter";
import { CartProvider } from "./cart/CartContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <CartProvider>
      <AppRouter />
    </CartProvider>
  </React.StrictMode>
);
